import { ThisWorkflowStep } from "@components/WorkflowCard/types";
import { WORKFLOW_ACTIONS } from "@typings/api-models";

const actionText = (actionStep: ThisWorkflowStep): string => {
  if (actionStep.eventName === WORKFLOW_ACTIONS.SEND_MESSAGE) {
    return 'Send Message';
  }
  return 'Action Type';
};

export default actionText;